import React, { FC } from 'react';
import { TCellIconProps } from '../../../types/index.types';

const CellIcon: FC<TCellIconProps> = (props): JSX.Element | null => {
  const { index, row, fadeIn, hideCell } = props;

  const data = row.getIconCellData(index);

  if (!data) return null;

  return (
    <div
      className={`model-detail-specification-table__spec model-detail-specification-table__spec--cell-icon model-detail-specification-table__cell-animation ${
        fadeIn ? 'model-detail-specification-table__cell-animation--show-animation' : ''
      } ${hideCell ? 'model-detail-specification-table__cell-animation--hide' : ''}`}
    >
      <img
        src={data.fields?.iconUrl?.value}
        alt={data.fields?.iconAlt?.value}
        className="model-detail-specification-table__spec--cell-icon-img"
      />
    </div>
  );
};

export default CellIcon;
